import React, { useEffect, useRef, useState } from "react";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef, ISelectOption } from "@/components/YhFormBox/Types";
import { useCustomerDiscountModel } from "../customerDiscountModel";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { ICustomerDiscountFormFields } from "../customerDiscountService";
import { getFormValidatorErrText } from "@/utils/utils"
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Description } from "@/components/YhBox/Description";
import useGlobalModel from "@/model/globalModel";
import { customerService } from "@/views/base/customer/customerService";
import { accountService } from "../../AccountService";
import { DictCodeEnmu } from "@/types/FmsDictEnums";
import { AuditDrawer } from "./auditDrawer";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";
export const CustomerDiscountDetail = () => {
    const {
        addFormVal,
        editFormVal,
        creditAcc, setCreditAcc,
        editcreditAcc, setEditCreditAcc,
        setAuditDrawerVisible,
        updateAddFormVal,
        updateEditFormVal,
        insertCustomerDiscount,
        editCustomerDiscount,
        getCustomerDiscountOne
    } = useCustomerDiscountModel();

    const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel();
    const formRef = useRef<IYhFormRef>();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const { fetchCustomerList, getDictNodeName, beShopDs, user: { shopCode } } = useGlobalModel(({ beShopDs, user }) => [beShopDs, user]);
    //编辑时， 没有缓存调用详情接口
    useEffect(() => {
        if (!Object.keys(editFormVal).length && detailsInfo.mode === "edit") {
            getCustomerDiscountOne(detailsInfo.id).then(async res => {
                let params = {
                    partnerCode: res?.customerCode,  //客户/供应商编码 
                    beCode: res.bentityCode as string,
                    status: 0,
                    creditFlag: 1,  //为记账类型的  1挂账 2现结
                    sourceApp: "fms",
                    shopCode
                }
                const { retData } = await accountService.find(params);
                if (retData.length) {
                    let accAll = retData?.map(item => ({
                        key: item.key,
                        label: item.name ?? "",
                        value: item.code ?? "",
                    })) ?? []
                    setEditCreditAcc(accAll)
                } else {
                    setEditCreditAcc([])
                }
            })
        }
    }, [detailsInfo])

    //清楚缓存
    useEffect(() => {
        return () => {
            !findNav("2-5-1") && updateAddFormVal(null);
            !findNav("2-5-2") && updateEditFormVal(null);
        }
    }, [selectedNavId])

    //关闭当前页
    const onClose = () => {
        replaceNav(selectedNavId, "2-5");
    }

    //表单提交
    const onSubmit = async () => {
        formRef.current?.validateFields().then(val => {
            if (detailsInfo.mode === "edit") {
                editCustomerDiscount({ ...val, id: detailsInfo.id }).then(res => {
                    res && onClose();
                    updateEditFormVal(null);
                })
            } else {
                insertCustomerDiscount(val).then(res => {
                    res && onClose();
                    updateAddFormVal(null);
                })
            }
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }
    //保留缓存及回显表单
    const saveCache = (val: { [key: string]: any }, isFormItem: boolean = true) => {
        isFormItem && formRef.current?.setFieldsValue(val);
        detailsInfo.mode === "edit" ? updateEditFormVal(val) : updateAddFormVal(val);
    }

    //回显选中供应商带出来的数据
    const getcustomer = async (id: string) => {
        let { retData: { records } } = await customerService.page({
            code: id,
            page: {
                pageNum: 1,
                pageSize: 1
            }
        });
        let res = records?.[0] ?? {};
        let data = {
            customerCode: res.code,
            customerName: res.name,
            contact: res.contact,
            phone: res.phone,
            //清空销售实体  及优惠账户信息
            bentityName: undefined,
            bentityCode: undefined,
            accountCode: undefined,
            accountName: undefined,
            accountArrears: undefined
        }
        setCreditAcc([]);
        saveCache(data);
    }

    //客户名称
    const customerChange = (value: string, option: ISelectOption) => {
        if (option && value) {
            getcustomer(value as string)
        }
    }

    //根据选择实体查找下面对应的授信账户
    const queryAccount = async (option: ISelectOption) => {
        let params = {
            partnerCode: addFormVal?.customerCode,  //客户/供应商编码 
            beCode: option.value as string,
            status: 0,
            creditFlag: 1,  //为记账类型的  1挂账 2现结
            sourceApp: "fms",
            shopCode
        }
        const { retData } = await accountService.find(params);
        if (retData.length) {
            let accAll = retData?.map(item => ({
                key: item.key,
                label: item.name ?? "",
                value: item.code ?? "",
                totaldebtamount: item?.totalDebtAmount ?? 0,
                usedamount: item?.usedAmount ?? 0,  //已用额度
                remainingamount: item?.remainingAmount ?? 0,  //剩余额度
            })) ?? []
            setCreditAcc(accAll);
            saveCache({ bentityName: option.label, bentityCode: option.value, accountCode: undefined, accountName: undefined, accountArrears: undefined });
        } else {
            message.warning("该实体下没有授信账户，请前去开户");
            setCreditAcc([])
            saveCache({ bentityName: option.label, bentityCode: option.value, accountCode: undefined, accountName: undefined, accountArrears: undefined });
        }
    }
    //销售实体
    const beCodeChange = (value: string, option: ISelectOption) => {
        if (detailsInfo.mode === "add" && addFormVal.customerCode) {
            value && queryAccount(option);
        } else {
            saveCache({ bentityName: "", bentityCode: "" });
            message.warning("请先选择客户后在选择实体")
        }
    }

    //优惠账户  优惠账户欠款=已用-剩余
    const accChange = (value: string, option: ISelectOption) => {
        if (value) {
            saveCache({ accountCode: option.value, accountName: option.label, accountArrears: +option.usedamount - +option.remainingamount });
        }
    }

    const onChange = (changedValues: { [key: string]: any }) => {
        saveCache(changedValues, false)
    }

    const baseFormItem: IYhFormItemsBox = {
        title: "基础信息",
        style: { padding: "10px 20px", marginBottom: "15px" },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户优惠单号",
                fieldName: "code",
                disable: true,
                placeholder: "自动生成"
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "销售实体",
                fieldName: "bentityCode",
                onSelectChange: beCodeChange,
                ds: beShopDs,
                rules: [{ required: true, message: "请选择销售实体" }],
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "优惠金额",
                fieldName: "discountAmount",
                rules: [{
                    required: true,
                    pattern: new RegExp(/^[+]?(\d+)$|^[+]?(\d+\.\d+)$/),
                    message: "输入不能为空且大于等于0的数字!"
                }],
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "机构审核意见",
                fieldName: "auditExplain",
                disable: true
            }, {
                type: FormItemTypeEnum.AsyncSelect,
                fieldLabel: "客户名称",
                fieldName: "customerCode",
                onSelectChange: customerChange,
                rules: [{ required: true, message: "请选择客户" }],
                disable: detailsInfo.mode === "edit",
                selectfetchList: fetchCustomerList,
                defaultQuery: detailsInfo.mode === "edit" ? editFormVal.customerName : addFormVal.customerName
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "优惠账户",
                fieldName: "accountCode",
                ds: detailsInfo.mode === "edit" ? editcreditAcc : creditAcc,
                onSelectChange: accChange,
                rules: [{ required: true, message: "请选择优惠账户" }],
                disable: detailsInfo.mode === "edit",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "申请说明",
                fieldName: "applyExplain",
                rules: [{ required: true, message: "请输入申请说明" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "财务审核意见",
                fieldName: "casherExplain",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系人",
                fieldName: "contact",
                rules: [{ required: true, message: "请输入联系人" }],
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "优惠账户欠款",
                fieldName: "accountArrears",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "申请人",
                fieldName: "createUser",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "机构审核人",
                fieldName: "audit",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "手机号",
                fieldName: "phone",
                rules: [{ required: true, message: "请输入联系人电话" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "优惠账户编码",
                fieldName: "accountCode",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "申请日期",
                fieldName: "createTime",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "机构审批日期",
                fieldName: "auditTime",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "从属门店",
                fieldName: "shopName",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "制单人",
                fieldName: "createUser",
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "财务",
                fieldName: "casher",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "财务审批日期",
                fieldName: "casherTime",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "制单时间",
                fieldName: "createTime",
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "修改人",
                fieldName: "updateUser",
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "修改时间",
                fieldName: "updateTime",
                disable: true
            },

            //带出字段
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "实体名称",
                fieldName: "bentityName",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户名称",
                fieldName: "customerName",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "优惠账户名称",
                fieldName: "accountName",
                hidden: true
            }

        ]
    };



    const customerDiscountFromConfig: IYhFormBox<ICustomerDiscountFormFields> = {
        formRef,
        labelCol: { span: 6 },
        labelAlign: "right",
        formValues: detailsInfo.mode === "edit" ? editFormVal : addFormVal,
        onChange,
        disabled: detailsInfo.mode === "edit",
        boxs: [baseFormItem]
    }


    const action = <>
        {detailsInfo.mode === "edit" ?
            <>
                <YhAuth resCode={ResourceAuthEnum.ACC_C_ED_D_APPROVE}>
                    <Button
                        className="mr-5"
                        type="link"
                        shape="round"
                        onClick={() => setAuditDrawerVisible({ visible: true, type: "audit" })}
                        disabled={editFormVal.status !== "favorable-status.apply"}
                    >机构审核</Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.ACC_C_ED_F_APPROVE}>
                    <Button
                        className="mr-5"
                        type="link"
                        shape="round"
                        onClick={() => setAuditDrawerVisible({ visible: true, type: "casher" })}
                        disabled={editFormVal.status !== "favorable-status.dep-approve"}
                    >财务审核</Button>
                </YhAuth>
            </> :
            <YhAuth resCode={ResourceAuthEnum.ACC_C_AD_APPLY}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onSubmit}
                >申请</Button>
            </YhAuth>
        }
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onClose}
        >返回</Button>
    </>;

    const orderStatu: IDescription[] = [
        {
            label: "客户优惠单",
            value: detailsInfo.mode === "edit" ? editFormVal?.code ?? " " : " ",
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: "状态",
            value: detailsInfo.mode === "edit" ? getDictNodeName(editFormVal?.status as DictCodeEnmu) ?? " " : "无",
            color: DescriptionColorEnum.green,
            status: true
        },
    ]

    return (
        <>
            <YhBox
                title={<>
                    {orderStatu.map((item, index) => <Description key={index} {...item} />)}
                </>}
                action={action}
            ></YhBox>
            <YhFormBox {...customerDiscountFromConfig} />
            <AuditDrawer />
        </>
    )
}